import ButtonCommonArrow from "@lhd/components/ButtonCommonArrow";
import ModalConfirm from "@lhd/components/Modal/ModalConfirm";
import { useSignV2 } from "@lhd/hooks";
import { Spin } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { ROLE_SIGNATURE } from "../../constants";
import { getCompanyId } from "@lhd/utility";

interface IProps {
  appType: string;
  appId: string;
  recordId: string;
  disabled: boolean;
  onClick?: () => void;
  role: ROLE_SIGNATURE;
}
const ButtonSign = (props: IProps) => {
  const { appType, appId, recordId, disabled, onClick, role } = props;
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const { companyId: companyIdParam } = useParams();
  const companyId = Number(companyIdParam || getCompanyId());

  const { mutateAsync: signAsync, isLoading: isLoadingSign } = useSignV2({
    appType: appType || "",
    appId: appId || "",
    recordId: recordId || "",
    companyId,
  });

  const handleConfirm = async () => {
    if (disabled) return;
    if (!Object.values(ROLE_SIGNATURE).includes(role)) return;
    await signAsync(role);
    setIsOpenConfirm(false);
    onClick?.();
  };

  return (
    <>
      <Spin spinning={!!isLoadingSign}>
        <ButtonCommonArrow
          disabled={disabled}
          onClick={() => {
            if (disabled) return;
            setIsOpenConfirm(true);
          }}
          style={{
            marginRight: 0,
          }}
        >
          電子署名
        </ButtonCommonArrow>
      </Spin>
      <ModalConfirm
        isOpen={isOpenConfirm}
        content={`本契約の内容に同意のうえ、署名を行います。\nよろしいでしょうか。`}
        isSubmitting={isLoadingSign}
        onOk={handleConfirm}
        onCancel={() => setIsOpenConfirm(false)}
        okText="署名する"
        cancelText="キャンセル"
      />
    </>
  );
};

export default ButtonSign;
